import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/** Fade + rise reveal for a set of elements when they enter the viewport. */
export function revealUp(
  targets: gsap.TweenTarget,
  trigger: Element,
  vars: gsap.TweenVars = {}
) {
  if (prefersReducedMotion()) return;
  // fromTo (not from): explicit end values survive React StrictMode's
  // double-mount, where from() can record an already-hidden state as the end.
  gsap.fromTo(
    targets,
    { y: 48, opacity: 0 },
    {
      y: 0,
      opacity: 1,
      duration: 1.1,
      ease: 'power3.out',
      stagger: 0.12,
      scrollTrigger: {
        trigger,
        start: 'top 78%',
        toggleActions: 'play none none none',
      },
      ...vars,
    }
  );
}

export { gsap, ScrollTrigger };
